import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import type { ChatUIAffectingMessage } from '@module/types/centrifuge/chatTypes';
import { isPersonalAdminMessage, isPersonalSupportMessage } from '@module/types/centrifuge/personalMessageTypes';
import { isAdminChatMessage, isBlindOffMessage, isBlindOnMessage, isCastGuestImgBlindOnMessage, isChatBlockCountryMessage, isChatIntroItem, isCustomMuteOnMessage, isEventAnimCoinMessage, isFanInMessage, isFanUpMessage, isFreezeOffMessage, isFreezeOnMessage, isFrozenMessage, isInfoMessage, isIntendedAlertMessage, isIntroEffectMessage, isItemCoinMessage, isKingFanInMessage, isKingFanUpMessage, isLayoutChatMessage, isLiveRoomRankMessage, isManagerInMessage, isManagerOffMessage, isManagerOnMessage, isMemberKickOutMessage, isMissionMessage, isMuteOffMessage, isMuteOnMessage, isNormalChatMessage, isRecommendMessage, isServiceBlindOnMessage, isServiceCastBlockMessage, isSponCoinMessage, isVIPFanInMessage } from '@module/types/centrifuge/public-message';
import { type Dispatch, memo, type SetStateAction } from 'react';
import ChatItemContainer from './ChatItemContainer';
import { AdminChat, BlindOffChat, BlindOnChat, CastGuestImgBlindOnChat, ChatBlockCountryChat, FanInChat, FanUpChat, FreezeOffChat, FreezeOnChat, FrozenChat, InfoChat, IntendedAlertChat, IntroChat, IntroEffectChat, KingFanInChat, KingFanUpChat, LayoutChat, LiveRoomRankChat, ManagerInChat, ManagerOffChat, ManagerOnChat, MemberKickOutChat, MissionChat, MuteOffChat, MuteOnChat, MuteStatusChat, NormalChat, PersonalAdminChat, PersonalSupportChat, RecommendChat, ServiceCastBlockChat, SponChat, VIPFanInChat } from './chat-item';
interface Props {
  item: ChatUIAffectingMessage;
  userIdx?: number;
  playInfo: PlayInfo;
  isRoomMaster: boolean;
  isManager: boolean;
  menuVisibleOffset?: number;
  setMenuVisibleOffset?: Dispatch<SetStateAction<number>>;
}
function ChatItem(t0) {
  const $ = _c(21);
  const {
    item,
    userIdx,
    playInfo,
    isRoomMaster,
    isManager,
    menuVisibleOffset,
    setMenuVisibleOffset
  } = t0;
  let t1;
  if ($[0] !== isManager || $[1] !== isRoomMaster || $[2] !== item || $[3] !== menuVisibleOffset || $[4] !== playInfo || $[5] !== setMenuVisibleOffset || $[6] !== userIdx) {
    t1 = (isSponCoinMessage(item) || isItemCoinMessage(item)) && <SponChat item={item} userIdx={userIdx} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} menuVisibleOffset={menuVisibleOffset} setMenuVisibleOffset={setMenuVisibleOffset} />;
    $[0] = isManager;
    $[1] = isRoomMaster;
    $[2] = item;
    $[3] = menuVisibleOffset;
    $[4] = playInfo;
    $[5] = setMenuVisibleOffset;
    $[6] = userIdx;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== item) {
    t2 = isChatIntroItem(item) && <IntroChat text={item.data.message} llIntro={item.data.variant === "ll"} />;
    $[8] = item;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== isManager || $[11] !== isRoomMaster || $[12] !== item || $[13] !== menuVisibleOffset || $[14] !== playInfo || $[15] !== setMenuVisibleOffset) {
    t3 = playInfo.chatMode !== "hide" && <>{isManagerInMessage(item) && <ManagerInChat item={item} />}{isManagerOnMessage(item) && <ManagerOnChat item={item} />}{isManagerOffMessage(item) && <ManagerOffChat item={item} />}{isKingFanInMessage(item) && <KingFanInChat item={item} />}{isFanInMessage(item) && <FanInChat item={item} />}{isVIPFanInMessage(item) && <VIPFanInChat item={item} />}{isCastGuestImgBlindOnMessage(item) && <CastGuestImgBlindOnChat item={item} />}{isBlindOnMessage(item) && <BlindOnChat item={item} />}{isBlindOffMessage(item) && <BlindOffChat item={item} />}{isMemberKickOutMessage(item) && <MemberKickOutChat item={item} />}{isMuteOnMessage(item) && <MuteOnChat item={item} />}{isMuteOffMessage(item) && <MuteOffChat item={item} />}{isCustomMuteOnMessage(item) && <MuteStatusChat />}{isFreezeOnMessage(item) && <FreezeOnChat item={item} />}{isFreezeOffMessage(item) && <FreezeOffChat item={item} />}{isFrozenMessage(item) && <FrozenChat item={item} />}{isChatBlockCountryMessage(item) && <ChatBlockCountryChat item={item} />}{(isServiceCastBlockMessage(item) || isServiceBlindOnMessage(item)) && <ServiceCastBlockChat />}{isIntroEffectMessage(item) && <IntroEffectChat item={item} />}{isLiveRoomRankMessage(item) && <LiveRoomRankChat item={item} />}{isInfoMessage(item) && <InfoChat item={item} />}{isFanUpMessage(item) && <FanUpChat item={item} />}{isKingFanUpMessage(item) && <KingFanUpChat item={item} />}{isRecommendMessage(item) && <RecommendChat item={item} />}{isMissionMessage(item) && <MissionChat item={item} />}{isIntendedAlertMessage(item) && <IntendedAlertChat item={item} />}{isLayoutChatMessage(item) && <LayoutChat item={item} />}{isEventAnimCoinMessage(item) && <LayoutChat item={item} />}{isNormalChatMessage(item) && <NormalChat item={item} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} menuVisibleOffset={menuVisibleOffset} setMenuVisibleOffset={setMenuVisibleOffset} />}{isPersonalAdminMessage(item) && <PersonalAdminChat item={item} />}{isPersonalSupportMessage(item) && item.data.message.whisper === "Y" && <PersonalSupportChat item={item} />}{isAdminChatMessage(item) && <AdminChat type={item.data.type} message={item.data.message} />}</>;
    $[10] = isManager;
    $[11] = isRoomMaster;
    $[12] = item;
    $[13] = menuVisibleOffset;
    $[14] = playInfo;
    $[15] = setMenuVisibleOffset;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
    t4 = <ChatItemContainer>{t1}{t2}{t3}</ChatItemContainer>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}
const MemoizedChatItem = memo(ChatItem);
MemoizedChatItem.displayName = 'ChatItem';
export default MemoizedChatItem;